export enum BlacklistQueryKeys {
	GetBlacklist = 'blacklist.getBlacklist',
}

export enum BlacklistMutationKeys {
	CreateBlacklistReport = 'blacklist.createBlacklistReport',
	UpdateBlacklistReport = 'blacklist.updateBlacklistReport',
	DeleteBlacklistReport = 'blacklist.deleteBlacklistReport',
}
